import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.js?url'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorkerUrl

export { pdfjsLib }

/** Convert PDF rect [x1,y1,x2,y2] (bottom-left origin) to canvas coords (top-left origin) */
export function pdfRectToCanvas(rect: number[], pageHeight: number) {
  const [x1, y1, x2, y2] = rect
  const left = Math.min(x1, x2)
  const width = Math.max(x1, x2) - left
  const top = pageHeight - Math.max(y1, y2)
  const height = Math.max(y1, y2) - Math.min(y1, y2)
  return { top, left, width, height }
}

export function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
